import { BoardCommand } from 'src/components/dispatch/assignment/types';

import { LongHaulTrip } from './types';

export type DraggedItem =
  | { kind: 'unassigned'; legRunIds: number[] }
  | { kind: 'trip'; trip: LongHaulTrip };

export type DropLocation =
  | { kind: 'work'; shiftTruckId: number; targetRowId: string }
  | { kind: 'unassigned' };

export function buildBoardCommand(input: {
  dragged: DraggedItem;
  drop: DropLocation | null;
}): BoardCommand | null {
  const { dragged, drop } = input;
  if (!drop) return null;

  if (dragged.kind === 'unassigned') {
    if (drop.kind !== 'work') return null;
    if (dragged.legRunIds.length === 0) return null;
    return {
      kind: 'assign',
      source: { scope: 'unassigned' },
      targetRowId: drop.targetRowId,
      legRunIds: dragged.legRunIds,
    };
  }

  const { trip } = dragged;
  if (trip.legRunIds.length === 0) return null;

  if (drop.kind === 'unassigned') {
    return { kind: 'unassign', source: { scope: 'trip', rowId: trip.rowId }, legRunIds: trip.legRunIds };
  }

  // 自分の勤務へのドロップは何もしない。
  // rowId 一致では足りない: rowIdFromTruck は rotationNumber を含むので、
  // 同じ勤務の前方回転からのドロップがすり抜ける。
  if (trip.shiftTruckId != null && trip.shiftTruckId === drop.shiftTruckId) return null;

  return {
    kind: 'assign',
    source: { scope: 'trip', rowId: trip.rowId },
    targetRowId: drop.targetRowId,
    legRunIds: trip.legRunIds,
  };
}
